(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kw-colour-preload"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kw-colour-preload')) {
    customElements.define(
      'kw-colour-preload',
      class extends HTMLElement {
        connectedCallback() {
          this.option = this.dataset.option || '';
          this.onChange = (event) => {
            const input = event.target;
            if (!(input instanceof HTMLInputElement) || input.type !== 'radio') return;
            if (!input.name.startsWith(`${this.option}-`)) return;
            this.swap(input.value);
          };
          document.addEventListener('change', this.onChange, true);
          const idle = window.requestIdleCallback || ((fn) => setTimeout(fn, 1200));
          idle(() => this.preload());
        }

        disconnectedCallback() {
          document.removeEventListener('change', this.onChange, true);
        }

        images(colour) {
          const template = [...this.querySelectorAll('template')].find((t) => t.dataset.colour === colour);
          return template ? [...template.content.querySelectorAll('img')] : [];
        }

        preload() {
          if (window.KoraPreloaded?.has(this.option + location.pathname)) return;
          window.KoraPreloaded = window.KoraPreloaded || new Set();
          window.KoraPreloaded.add(this.option + location.pathname);
          this.querySelectorAll('template').forEach((template) => {
            template.content.querySelectorAll('img').forEach((source) => {
              const img = new Image();
              img.decoding = 'async';
              img.sizes = source.sizes;
              img.srcset = source.srcset;
              img.src = source.src;
            });
          });
        }

        swap(colour) {
          const sources = this.images(colour);
          if (!sources.length) return;
          const gallery = this.closest('media-gallery') || document.querySelector('media-gallery');
          if (!gallery) return;
          const targets = [...gallery.querySelectorAll('.product-media img')].filter((img) => !img.closest('dialog'));
          targets.slice(0, sources.length).forEach((img, index) => {
            const source = sources[index];
            img.removeAttribute('loading');
            img.srcset = source.srcset;
            img.src = source.src;
            img.alt = source.alt;
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kw-price-slider"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kw-price-slider')) {
    customElements.define(
      'kw-price-slider',
      class extends HTMLElement {
        connectedCallback() {
          this.lo = this.querySelector('[data-kw-lo]');
          this.hi = this.querySelector('[data-kw-hi]');
          this.track = this.querySelector('.kw-price__track');
          this.loLabel = this.querySelector('[data-kw-lo-label]');
          this.hiLabel = this.querySelector('[data-kw-hi-label]');
          const facet = this.closest('price-facet-component');
          this.minInput = facet?.querySelector('input[ref="minInput"]');
          this.maxInput = facet?.querySelector('input[ref="maxInput"]');
          this.onInput = (event) => this.sync(event.target);
          this.lo.addEventListener('input', this.onInput);
          this.hi.addEventListener('input', this.onInput);
        }
        disconnectedCallback() {
          this.lo?.removeEventListener('input', this.onInput);
          this.hi?.removeEventListener('input', this.onInput);
        }
        sync(moved) {
          let lo = Number(this.lo.value);
          let hi = Number(this.hi.value);
          if (lo > hi) {
            if (moved === this.lo) this.lo.value = String((lo = hi));
            else this.hi.value = String((hi = lo));
          }
          const top = Number(this.hi.max) || 1;
          this.track.style.setProperty('--lo', `${(lo / top) * 100}%`);
          this.track.style.setProperty('--hi', `${(hi / top) * 100}%`);
          const symbol = this.dataset.symbol || '';
          const fmt = (n) => symbol + n.toLocaleString('en-IN');
          this.loLabel.textContent = fmt(lo);
          this.hiLabel.textContent = fmt(hi);
          if (this.minInput) this.minInput.value = lo > 0 ? String(lo) : '';
          if (this.maxInput) this.maxInput.value = hi < top ? String(hi) : '';
          this.lo.style.zIndex = lo >= top - 100 ? '2' : '1';
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kw-rail"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kw-rail')) {
    customElements.define(
      'kw-rail',
      class extends HTMLElement {
        connectedCallback() {
          const root = this.closest('.kw-rail');
          this.buttons = root ? [...root.querySelectorAll('.kw-rail__btn')] : [];
          this.buttons.forEach((btn) =>
            btn.addEventListener('click', () => {
              const dir = Number(btn.dataset.dir);
              this.scrollBy({ left: dir * this.clientWidth * 0.9 });
            })
          );
          this.update = this.update.bind(this);
          this.addEventListener('scroll', this.update, { passive: true });
          window.addEventListener('resize', this.update);
          requestAnimationFrame(this.update);
        }
        disconnectedCallback() {
          window.removeEventListener('resize', this.update);
        }
        update() {
          const max = this.scrollWidth - this.clientWidth - 2;
          this.buttons.forEach((btn) => {
            btn.disabled = Number(btn.dataset.dir) < 0 ? this.scrollLeft <= 2 : this.scrollLeft >= max;
          });
          const root = this.closest('.kw-rail');
          if (root) root.classList.toggle('kw-rail--static', max <= 0);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
